module.exports = __webpack_public_path__ + "loading.svg?6e5360e85c2dba1aef1e3bc136f618bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/layout/loading.svg
// module id = 46
// module chunks = 0